var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.uiStateStore.loading)?_c('div',[_c('div',{attrs:{"id":"loader"}},[_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":""}})],1)]):_vm._e(),_c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('router-view')],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }